module.exports = __webpack_public_path__ + "img/P150T_weapon_104.5741de9f.png";